/**
 * @prettier
 */

// PDP Reducers
import carouselReducer from './carouselReducer';
import listingReducer from './listingReducer';
import listingExtendedReducer from './listingExtendedReducer';
import listingPageReducer from './listingPageReducer';
import loginReducer from './loginReducer';
import systemReducer from './systemReducer';
import translationsReducer from './translationsReducer';
import reviewsReducer from './reviewsReducer';
import headerReducer from './headerReducer';
import tripDetailsReducer from './tripDetailsReducer';
import guestSelectorReducer from './guestSelectorReducer';
import datePickerReducer from './datePickerReducer';
import travelerFeaturesReducer from './travelerFeaturesReducer';
import mapReducer from './mapReducer';
import contactOwnerFormReducer from './contactOwnerFormReducer';
import abacusTestsReducer from './abacusTestsReducer';
import navigationReducer from './navigationReducer';

// External Reducers
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';
import {toasterReducers} from '@homeaway/react-toaster';

const reducers = {
    carouselReducer,
    listingReducer,
    listingExtendedReducer,
    listingPageReducer,
    loginReducer,
    systemReducer,
    translationsReducer,
    reviewsReducer,
    headerReducer,
    tripDetailsReducer,
    guestSelectorReducer,
    datePickerReducer,
    mapReducer,
    travelerFeaturesReducer,
    contactOwnerFormReducer,
    abacusTestsReducer,
    navigationReducer,
    tripboardButton: tripboardButtonReducer,
    toasts: toasterReducers
};

export default reducers;
